import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FormBody from '_components/formBody'
import { createFieldMissingErrorMessage } from '_utils/helperFunction'

import styles from './styles.css'

export default class InviteForm extends Component {
  static propTypes = {
    fromName: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSend: PropTypes.func.isRequired,
  }

  static defaultProps = {
    fromName: '',
  }

  state = {
    name: '',
    email: '',
    message: '',
  }

  componentDidMount() {
    this.inputRef.focus()
  }

  onInputChange = e => {
    const { id, value } = e.target
    this.setState({ [id]: value })
  }

  onSend = () => {
    const { onSend, onCancel, fromName } = this.props
    const { name: toName, email: toEmail, message } = this.state

    if (!toName || !toEmail || !message) {
      const errorMsg = createFieldMissingErrorMessage({ name: toName, email: toEmail, message })
      this.props.displayError(errorMsg)
    } else {
      const payload = {
        toEmail,
        toName,
        message,
        fromName,
      }
      onSend(payload)
      onCancel()
    }
  }

  onCancel = () => {
    const { onCancel } = this.props
    onCancel()
  }

  render() {
    const { name, email, message } = this.state
    const buttons = [
      { label: 'Send', onClick: this.onSend },
      { label: 'Cancel', onClick: this.onCancel },
    ]
    return (
      <FormBody buttons={buttons} style={{ padding: '0 20px' }}>
        <input
          ref={el => (this.inputRef = el)}
          id="name"
          type="text"
          placeholder="Collaborator Name"
          className={styles.formInput}
          value={name}
          onChange={this.onInputChange}
        />
        <input
          id="email"
          type="text"
          placeholder="Collaborator Email"
          className={styles.formInput}
          value={email}
          onChange={this.onInputChange}
        />
        <textarea
          id="message"
          placeholder="Message"
          rows={5}
          value={message}
          onChange={this.onInputChange}
          className={styles.formTextArea}
          onKeyPress={this.onKeyPress}
        />
      </FormBody>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/collaborate/collaborator-panel/invite-form/index.js